<section
    data-testid="block-media-text"
    hBindSPANavigationForCTA
    [hAnimateOnScroll]="{
        animate: blockMediaText.hasAnimation,
        threshold: 0.2,
    }"
    class="block-media-text"
    [ngClass]="blockMediaText.align ? blockMediaText.align : ''">
    <div class="block-text">
        <div [innerHtml]="blockMediaText.text | resolveTokens: blockMediaText.tokens | trustHtml" class="text"></div>
        @if (vtoDataArray) {
            @for (vto of vtoDataArray; track vto) {
                <div class="align-cta-vto">
                    <h-cta-vto-button [id]="vto.vtoType" [text]="vto.text" [vtoType]="vto.vtoType"></h-cta-vto-button>
                </div>
            }
        }
    </div>
    @if (blockMediaText.media) {
        <div class="media">
            <h-media-cta [media]="blockMediaText.media" [preloadPoster]="shouldPreloadMedia"></h-media-cta>
        </div>
    }
</section>
